import React from 'react'
import * as Styled from './DetailContentWrapper.styles'
import { Grid } from 'components/atoms'

/**
 * @returns {*}
 * @constructor
 */
const DetailContentWrapper = ({ children, printAsBlock = false }) => (
  <Styled.ContentWrapper>
    <Grid container className={ printAsBlock ? 'print-as-block' : null }>
      <Grid item xs={ 12 } md={ 4 } />
      <Grid item xs={ 12 } md={ 8 }>
        {children}
      </Grid>
    </Grid>
  </Styled.ContentWrapper>
)

export default DetailContentWrapper
